import React, { FC, PropsWithChildren, useContext } from 'react'
import { LocaleLink } from '../../common/intl/LocaleLink'
import { LocalPath } from '../../common/intl/LocalPath'
import { MessagesContext } from '../../common/intl/MessagesContext'

export const FooterMenu: FC = () => {
  const messages = useContext(MessagesContext)

  return (
    <nav className="flex gap-5">
      <TheLink to={LocalPath.WebcamTest}>{messages.webcam?.name}</TheLink>
      <TheLink to={LocalPath.MicTest}>{messages.mic?.name}</TheLink>
      <TheLink to={LocalPath.Headphones}>{messages.headphones?.name}</TheLink>
    </nav>
  )
}

export const TheLink: FC<{ to: LocalPath } & PropsWithChildren> = ({ to, children }) => {
  return (
    <LocaleLink className="no-underline hover:underline" to={to} activeClassName="text-white">
      {children}
    </LocaleLink>
  )
}
